<template>
  <div class="activity-container" @click.prevent="executeCompleteStep" :class="{'active':currentActive, 'completed':completed, 'gold-completed':goldCompleted}">
    <div class="activity-circle-background"></div>
    <check-mark-small class="svg-icon"></check-mark-small>
    <img class="kiwi-lotus" src="../assets/win/kiwi-lotus-only.png">
  </div>
</template>

<script>
import CheckMarkSmall from '../assets/icons/check-mark-small.svg?inline'

export default{
  name: 'win-activity',
  components: {
    'check-mark-small': CheckMarkSmall,
  },
  computed:{
    currentActive(){
      // const junkCreated = 1555365847
      const now = new Date()
      const weekInSeconds = 604800
      // const timeDiff = (now.getTime() / 1000) - junkCreated
      const timeDiff = (now.getTime() / 1000) - this.created
      return timeDiff >= this.step * weekInSeconds && !this.completed
    }
  },
  methods:{
    executeCompleteStep(){
      if(this.currentActive){
        this.completeStep(this.stepId, this.step)
      }
    }
  },
  props: {
    created: Number,
    completed: Boolean,
    goldCompleted: Boolean,
    step: Number,
    completeStep: Function,
    stepId: String
  }
}
</script>

<style scoped lang="scss">
/** split-container **/
@import '../theme';

.activity-container {
  position: relative;
  width: 56px;
  height: 56px;
  margin: 0;
  transform: scale(.6);
  
  @include media-breakpoint-up(sm) {
    margin: 0 12px;
    transform: none;
  }

  .activity-circle-background {
    width: 56px;
    height: 56px;
    background-color: zespri-brand-color(dark-green);
    border-radius: 50%;
    display: none;
  }

  .svg-icon {
    position: absolute;
    top: -5px;
    left: -5px;
    width: 27px;
    display: none;
  }

  .kiwi-lotus {
    position: absolute;
    width: 65px;
    bottom: -5px;
    right: -10px;
    opacity: .2;
  }

  .active .kiwi-lotus {
    opacity: 1;
    cursor: pointer;
  }
  
  &.completed {
    .svg-icon {
      display: block;
    }
    
    .activity-circle-background {
      display: block;
      background-color: zespri-brand-color(dark-green);
    }
    
    .kiwi-lotus {
      opacity: 1;
    }
  }
  
  &.gold-completed {
    .svg-icon {
      display: block;
    }
    
    .activity-circle-background {
      display: block;
      background-color: zespri-brand-color(yellow);
    }
    
    .kiwi-lotus {
      opacity: 1;
    }
  }
}
</style>
